import { GET_SETTING, UPDATE_SETTING, UPDATE_GAME_STATUS } from "./types";

const initialState = {
  setting: {},
};

const settingReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SETTING:
      return {
        ...state,
        setting: action.payload
      };

    case UPDATE_SETTING:
      return {
        ...state,
        setting: {
          ...state.setting,
          googlePlaySwitch: action.payload.googlePlaySwitch,
          stripeSwitch: action.payload.stripeSwitch,
          isAppActive: action.payload.isAppActive,
          importantAnnouncement: {
            ...state.setting.importantAnnouncement,
            isActive: action.payload.importantAnnouncement.isActive,
          },
        },
      };

    case UPDATE_GAME_STATUS:
      return {
        ...state,
        setting: {
          ...state.setting,
          activeGames: action.payload.activeGames,
        },
      };

    default:
      return state;
  }
};

export default settingReducer;
